module.exports = __webpack_public_path__ + "static/reviews-bg-27ec931e59a83e14d81972e154513265.png";